import React from "react";
import { IAppIco } from "../types";

export const AppIcon: React.FC<IAppIco> = ({
    asset,
    stroke,
    fill,
    height,
    width,
    className,
}) => {
    const _strokeCommonProps = {
        strokeWidth: "1.5",
        strokeLinecap: "round" as any,
        strokeLinejoin: "round" as any,
    };
    const _fillCommonProps = {
        fillRule: "evenodd" as any,
        clipRule: "evenodd" as any,
    };
    const _classList = `${className || ""} ss-dashboard-wrapper-ico-${asset}`;
    let iconSvg: any = (
        <svg
            className={`stroke-ico ${_classList}`}
            width={width || "24"}
            height={height || "24"}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.3066 7.62358L20.6842 6.54349C20.1576 5.62957 18.9907 5.31429 18.0755 5.83869V5.83869C17.6399 6.09531 17.1201 6.16812 16.6307 6.04106C16.1413 5.91399 15.7226 5.59749 15.4668 5.16134C15.3023 4.88412 15.2139 4.56836 15.2105 4.24601V4.24601C15.2254 3.72919 15.0304 3.22837 14.67 2.85764C14.3096 2.48691 13.8145 2.27783 13.2975 2.27805H12.0435C11.5369 2.27804 11.0513 2.47988 10.694 2.83891C10.3367 3.19795 10.1371 3.68456 10.1396 4.19109V4.19109C10.1246 5.23689 9.27245 6.07678 8.22654 6.07667C7.90418 6.07332 7.58843 5.98491 7.3112 5.82038V5.82038C6.39603 5.29598 5.22908 5.61126 4.70251 6.52519L4.03432 7.62358C3.50838 8.53636 3.81937 9.70258 4.72997 10.2323V10.2323C5.32187 10.574 5.6865 11.2056 5.6865 11.889C5.6865 12.5725 5.32187 13.204 4.72997 13.5458V13.5458C3.82053 14.0719 3.5092 15.2353 4.03432 16.1453V16.1453L4.66589 17.2346C4.91262 17.6798 5.32657 18.0083 5.81616 18.1474C6.30575 18.2866 6.83061 18.2249 7.27459 17.976V17.976C7.71105 17.7213 8.23116 17.6515 8.71931 17.7822C9.20746 17.9128 9.62321 18.233 9.87413 18.6716C10.0387 18.9489 10.1271 19.2646 10.1304 19.587V19.587C10.1304 20.6435 10.9869 21.5 12.0435 21.5H13.2975C14.3505 21.5 15.2055 20.6491 15.2105 19.5961V19.5961C15.2081 19.088 15.4088 18.6 15.7681 18.2407C16.1274 17.8814 16.6154 17.6806 17.1236 17.6831C17.4451 17.6917 17.7596 17.7797 18.0389 17.9394V17.9394C18.9517 18.4653 20.1179 18.1543 20.6476 17.2437V17.2437L21.3066 16.1453C21.5617 15.7075 21.6317 15.186 21.5012 14.6963C21.3706 14.2067 21.0502 13.7893 20.611 13.5366V13.5366C20.1717 13.2839 19.8514 12.8665 19.7208 12.3769C19.5902 11.8873 19.6602 11.3658 19.9153 10.9279C20.0812 10.6383 20.3213 10.3982 20.611 10.2323V10.2323C21.5161 9.70286 21.8264 8.54346 21.3066 7.63274V7.63274V7.62358Z"
                stroke={stroke || "inherit"}
                {..._strokeCommonProps}
            />
            <circle
                cx="12.675"
                cy="11.889"
                r="2.63616"
                stroke={stroke || "inherit"}
                {..._strokeCommonProps}
            />
        </svg>
    );
    switch (asset) {
        case "dashboard":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M16.2853 2H19.5519C20.9035 2 21.9998 3.1059 21.9998 4.47018V7.7641C21.9998 9.12735 20.9035 10.2343 19.5519 10.2343H16.2853C14.9328 10.2343 13.8364 9.12735 13.8364 7.7641V4.47018C13.8364 3.1059 14.9328 2 16.2853 2Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                        {..._fillCommonProps}
                    />
                    <path
                        d="M4.44892 2H7.71449C9.06703 2 10.1634 3.1059 10.1634 4.47018V7.7641C10.1634 9.12735 9.06703 10.2343 7.71449 10.2343H4.44892C3.09638 10.2343 2 9.12735 2 7.7641V4.47018C2 3.1059 3.09638 2 4.44892 2Z"
                        stroke={stroke || "#inherit"}
                        {..._strokeCommonProps}
                        {..._fillCommonProps}
                    />
                    <path
                        d="M4.44892 13.7657H7.71449C9.06703 13.7657 10.1634 14.8716 10.1634 16.2369V19.5298C10.1634 20.8941 9.06703 22 7.71449 22H4.44892C3.09638 22 2 20.8941 2 19.5298V16.2369C2 14.8716 3.09638 13.7657 4.44892 13.7657Z"
                        stroke={stroke || "#inherit"}
                        {..._strokeCommonProps}
                        {..._fillCommonProps}
                    />
                    <path
                        d="M16.2853 13.7657H19.5519C20.9035 13.7657 21.9998 14.8716 21.9998 16.2369V19.5298C21.9998 20.8941 20.9035 22 19.5519 22H16.2853C14.9328 22 13.8364 20.8941 13.8364 19.5298V16.2369C13.8364 14.8716 14.9328 13.7657 16.2853 13.7657Z"
                        stroke={stroke || "#inherit"}
                        {..._fillCommonProps}
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "clock":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        {..._fillCommonProps}
                        d="M21.25 12.0005C21.25 17.1095 17.109 21.2505 12 21.2505C6.891 21.2505 2.75 17.1095 2.75 12.0005C2.75 6.8915 6.891 2.7505 12 2.7505C17.109 2.7505 21.25 6.8915 21.25 12.0005Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M15.4311 14.9429L11.6611 12.6939V7.84691"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "plane":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M15.8554 8.12111L10.1916 13.8227L3.56064 9.74147C2.69176 9.20657 2.86787 7.88697 3.8467 7.60287L19.5022 3.04743C20.3925 2.78978 21.2156 3.62446 20.949 4.51889L16.304 20.1582C16.013 21.1369 14.7082 21.3064 14.1809 20.4325L10.1916 13.8227"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );
            break;

        case "schedule":
            iconSvg = (
                <svg
                    className={`fill-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        {..._fillCommonProps}
                        fill={fill || "inherit"}
                        d="M16.335 3.50002H7.66598C4.2684 3.50002 2.00098 5.75019 2.00098 8.97237V16.5278C2.00098 19.7534 4.26167 22.0002 7.66598 22.0002H16.334C19.7386 22.0002 22.001 19.753 22.001 16.5278V8.97237C22.001 5.74733 19.7388 3.50002 16.335 3.50002ZM7.66598 4.88753H16.335C18.8855 4.88753 20.501 6.49239 20.501 8.97237V16.5278C20.501 19.0079 18.8854 20.6127 16.334 20.6127H7.66598C5.11512 20.6127 3.50098 19.0085 3.50098 16.5278V8.97237C3.50098 6.49554 5.12132 4.88753 7.66598 4.88753ZM9.91309 16.7866C9.91309 17.2888 10.3217 17.6974 10.8247 17.6974C11.3276 17.6974 11.7362 17.2888 11.7362 16.7866C11.7362 16.2844 11.3276 15.875 10.8247 15.875C10.3217 15.875 9.91309 16.2844 9.91309 16.7866ZM14.2324 17.6974C13.7294 17.6974 13.3208 17.2888 13.3208 16.7866C13.3208 16.2844 13.7294 15.875 14.2324 15.875C14.7353 15.875 15.1439 16.2844 15.1439 16.7866C15.1439 17.2888 14.7353 17.6974 14.2324 17.6974ZM16.729 16.7866C16.729 17.2888 17.1376 17.6974 17.6406 17.6974C18.1435 17.6974 18.5521 17.2888 18.5521 16.7866C18.5521 16.2844 18.1435 15.875 17.6406 15.875C17.1376 15.875 16.729 16.2844 16.729 16.7866Z"
                    />
                    <path
                        fill={fill || "inherit"}
                        d="M19.8258 9.62238C21.0266 9.62238 22 9.95514 22 10.3656C22 10.7419 21.182 11.0529 20.1208 11.1021L19.8258 11.1089H4.17424C2.97344 11.1089 2 10.7761 2 10.3656C2 9.98935 2.81796 9.67838 3.87921 9.62916L4.17424 9.62238H19.8258Z"
                    />
                    <path
                        fill={fill || "inherit"}
                        d="M19.8258 10.3656C21.0266 10.3656 22 10.6984 22 11.1089C22 11.4852 21.182 11.7961 20.1208 11.8454L19.8258 11.8521H4.17424C2.97344 11.8521 2 11.5194 2 11.1089C2 10.7326 2.81796 10.4216 3.87921 10.3724L4.17424 10.3656H19.8258Z"
                    />
                </svg>
            );

            break;

        case "calendar":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M3.59265 9.40427H21.4166"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M16.9421 13.3097H16.9514"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M12.5046 13.3097H12.5139"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M8.0579 13.3097H8.06717"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M16.9421 17.1962H16.9514"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M12.5046 17.1962H12.5139"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M8.0579 17.1962H8.06717"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M16.5437 2V5.29078"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M8.46552 2V5.29078"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.7383 3.57919H8.27096C5.33427 3.57919 3.5 5.21513 3.5 8.22222V17.2719C3.5 20.3262 5.33427 22 8.27096 22H16.729C19.675 22 21.5 20.3546 21.5 17.3475V8.22222C21.5092 5.21513 19.6842 3.57919 16.7383 3.57919Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );
            break;

        case "wallet":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M21.6389 14.3958H17.5906C16.1042 14.3949 14.8993 13.1909 14.8984 11.7045C14.8984 10.218 16.1042 9.01413 17.5906 9.01322H21.6389"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M18.049 11.6429H17.7373"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        {..._fillCommonProps}
                        d="M7.74766 3H16.3911C19.2892 3 21.6388 5.34951 21.6388 8.24766V15.4247C21.6388 18.3229 19.2892 20.6724 16.3911 20.6724H7.74766C4.84951 20.6724 2.5 18.3229 2.5 15.4247V8.24766C2.5 5.34951 4.84951 3 7.74766 3Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M7.03516 7.53816H12.4341"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "docs":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M16.2162 16.2234H8.99622"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M16.2162 12.0369H8.99622"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M11.7513 7.86008H8.99631"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        {..._fillCommonProps}
                        d="M16.4086 2.74979C16.4086 2.74979 8.73161 2.75379 8.71961 2.75379C5.95961 2.77079 4.25061 4.58679 4.25061 7.35679V16.5528C4.25061 19.3368 5.97261 21.1598 8.75661 21.1598C8.75661 21.1598 16.4326 21.1568 16.4456 21.1568C19.2056 21.1398 20.9156 19.3228 20.9156 16.5528V7.35679C20.9156 4.57279 19.1926 2.74979 16.4086 2.74979Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "folder":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <path
                        {..._fillCommonProps}
                        d="M21.9446 15.7579C21.9446 19.336 19.836 21.4446 16.2579 21.4446H8.47173C4.88444 21.4446 2.77588 19.336 2.77588 15.7579V7.9626C2.77588 4.38444 4.09031 2.27588 7.66847 2.27588H9.66749C10.3858 2.27588 11.0621 2.61406 11.4931 3.18868L12.4059 4.40269C12.8378 4.97618 13.5135 5.31406 14.2315 5.31549H17.0611C20.6484 5.31549 21.972 7.14108 21.972 10.7923L21.9446 15.7579Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M7.55896 14.4891H17.1524"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "work":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M3.30411 15.477C3.30411 15.477 3.44611 17.215 3.47911 17.763C3.52311 18.498 3.80711 19.319 4.28111 19.889C4.95011 20.697 5.73811 20.982 6.79011 20.984C8.02711 20.986 17.0221 20.986 18.2591 20.984C19.3111 20.982 20.0991 20.697 20.7681 19.889C21.2421 19.319 21.5261 18.498 21.5711 17.763C21.6031 17.215 21.7451 15.477 21.7451 15.477"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M8.996 5.32949V4.95849C8.996 3.73849 9.984 2.75049 11.204 2.75049H13.786C15.005 2.75049 15.994 3.73849 15.994 4.95849L15.995 5.32949"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M12.495 16.6782V15.3842"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.24991 8.38909V11.8561C5.16791 13.1211 7.46591 14.0071 9.98791 14.3581C10.2899 13.2571 11.2829 12.4501 12.4899 12.4501C13.6779 12.4501 14.6909 13.2571 14.9729 14.3681C17.5049 14.0171 19.8119 13.1311 21.7399 11.8561V8.38909C21.7399 6.69509 20.3769 5.33109 18.6829 5.33109H6.31691C4.62291 5.33109 3.24991 6.69509 3.24991 8.38909Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "setting":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21.3066 7.62358L20.6842 6.54349C20.1576 5.62957 18.9907 5.31429 18.0755 5.83869V5.83869C17.6399 6.09531 17.1201 6.16812 16.6307 6.04106C16.1413 5.91399 15.7226 5.59749 15.4668 5.16134C15.3023 4.88412 15.2139 4.56836 15.2105 4.24601V4.24601C15.2254 3.72919 15.0304 3.22837 14.67 2.85764C14.3096 2.48691 13.8145 2.27783 13.2975 2.27805H12.0435C11.5369 2.27804 11.0513 2.47988 10.694 2.83891C10.3367 3.19795 10.1371 3.68456 10.1396 4.19109V4.19109C10.1246 5.23689 9.27245 6.07678 8.22654 6.07667C7.90418 6.07332 7.58843 5.98491 7.3112 5.82038V5.82038C6.39603 5.29598 5.22908 5.61126 4.70251 6.52519L4.03432 7.62358C3.50838 8.53636 3.81937 9.70258 4.72997 10.2323V10.2323C5.32187 10.574 5.6865 11.2056 5.6865 11.889C5.6865 12.5725 5.32187 13.204 4.72997 13.5458V13.5458C3.82053 14.0719 3.5092 15.2353 4.03432 16.1453V16.1453L4.66589 17.2346C4.91262 17.6798 5.32657 18.0083 5.81616 18.1474C6.30575 18.2866 6.83061 18.2249 7.27459 17.976V17.976C7.71105 17.7213 8.23116 17.6515 8.71931 17.7822C9.20746 17.9128 9.62321 18.233 9.87413 18.6716C10.0387 18.9489 10.1271 19.2646 10.1304 19.587V19.587C10.1304 20.6435 10.9869 21.5 12.0435 21.5H13.2975C14.3505 21.5 15.2055 20.6491 15.2105 19.5961V19.5961C15.2081 19.088 15.4088 18.6 15.7681 18.2407C16.1274 17.8814 16.6154 17.6806 17.1236 17.6831C17.4451 17.6917 17.7596 17.7797 18.0389 17.9394V17.9394C18.9517 18.4653 20.1179 18.1543 20.6476 17.2437V17.2437L21.3066 16.1453C21.5617 15.7075 21.6317 15.186 21.5012 14.6963C21.3706 14.2067 21.0502 13.7893 20.611 13.5366V13.5366C20.1717 13.2839 19.8514 12.8665 19.7208 12.3769C19.5902 11.8873 19.6602 11.3658 19.9153 10.9279C20.0812 10.6383 20.3213 10.3982 20.611 10.2323V10.2323C21.5161 9.70286 21.8264 8.54346 21.3066 7.63274V7.63274V7.62358Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <circle
                        cx="12.675"
                        cy="11.889"
                        r="2.63616"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "help":
            iconSvg = (
                <svg
                    className={`fill-ico ${_classList}`}
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                >
                    <path
                        d="M15 3.43774C21.3863 3.43774 26.5625 8.61524 26.5625 15.0002C26.5625 21.3852 21.3863 26.5627 15 26.5627C8.615 26.5627 3.4375 21.3852 3.4375 15.0002C3.4375 8.61524 8.615 3.43774 15 3.43774Z"
                        stroke={stroke || "#272727"}
                        {..._strokeCommonProps}
                        {..._fillCommonProps}
                    />
                    <path
                        d="M10.625 12.2011C10.625 11.6782 10.8029 11.1498 11.1587 10.6159C11.5146 10.0764 12.0337 9.63061 12.7162 9.27834C13.3987 8.92607 14.195 8.74994 15.105 8.74994C15.9508 8.74994 16.6975 8.89855 17.345 9.19578C17.9925 9.4875 18.4913 9.88655 18.8413 10.3929C19.1971 10.8993 19.375 11.4497 19.375 12.0442C19.375 12.512 19.2729 12.9221 19.0688 13.2744C18.8704 13.6266 18.6312 13.9321 18.3512 14.1908C18.0771 14.444 17.5812 14.8733 16.8637 15.4788C16.6654 15.6494 16.505 15.8008 16.3825 15.9329C16.2658 16.0595 16.1783 16.1778 16.12 16.2879C16.0617 16.3925 16.015 16.4998 15.98 16.6099C15.9508 16.7145 15.9042 16.9016 15.84 17.1713C15.7292 17.7438 15.3821 18.03 14.7987 18.03C14.4954 18.03 14.2387 17.9364 14.0287 17.7493C13.8246 17.5621 13.7225 17.2842 13.7225 16.9154C13.7225 16.453 13.7983 16.054 13.95 15.7182C14.1017 15.377 14.3029 15.0797 14.5537 14.8266C14.8046 14.5679 15.1429 14.2624 15.5687 13.9101C15.9421 13.6019 16.2104 13.3707 16.3737 13.2166C16.5429 13.057 16.6829 12.8808 16.7937 12.6882C16.9104 12.4955 16.9687 12.2864 16.9687 12.0607C16.9687 11.6204 16.7937 11.2488 16.4437 10.9461C16.0996 10.6434 15.6533 10.492 15.105 10.492C14.4633 10.492 13.9908 10.6461 13.6875 10.9544C13.3842 11.2571 13.1275 11.7057 12.9175 12.3001C12.7192 12.9221 12.3429 13.2331 11.7888 13.2331C11.4621 13.2331 11.185 13.1258 10.9575 12.9111C10.7358 12.6909 10.625 12.4543 10.625 12.2011ZM14.895 21.2499C14.5392 21.2499 14.2271 21.1426 13.9587 20.9279C13.6962 20.7078 13.565 20.4023 13.565 20.0115C13.565 19.6647 13.6933 19.373 13.95 19.1363C14.2067 18.8997 14.5217 18.7813 14.895 18.7813C15.2625 18.7813 15.5717 18.8997 15.8225 19.1363C16.0733 19.373 16.1987 19.6647 16.1987 20.0115C16.1987 20.3968 16.0675 20.6995 15.805 20.9197C15.5425 21.1399 15.2392 21.2499 14.895 21.2499Z"
                        fill={fill || "#272727"}
                    />
                </svg>
            );

            break;

        case "burger-menu":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "33"}
                    height={height || "32"}
                    viewBox="0 0 33 32"
                    fill="none"
                >
                    <path
                        d="M6.875 24H26.125"
                        stroke={stroke || "#272727"}
                        strokeWidth="3"
                        strokeLinecap="round"
                    />
                    <path
                        d="M6.875 16H26.125"
                        stroke={stroke || "#272727"}
                        strokeWidth="3"
                        strokeLinecap="round"
                    />
                    <path
                        d="M6.875 8H26.125"
                        stroke={stroke || "#272727"}
                        strokeWidth="3"
                        strokeLinecap="round"
                    />
                </svg>
            );

            break;

        case "up-square":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        {..._fillCommonProps}
                        d="M16.334 2.75H7.665C4.645 2.75 2.75 4.889 2.75 7.916V16.084C2.75 19.111 4.635 21.25 7.665 21.25H16.334C19.364 21.25 21.25 19.111 21.25 16.084V7.916C21.25 4.889 19.364 2.75 16.334 2.75Z"
                        stroke="#43A115"
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M12 7.914L12 16.086"
                        stroke="#43A115"
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M8.25205 11.6777L12 7.9137L15.748 11.6777"
                        stroke="#43A115"
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "down-square":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        {..._fillCommonProps}
                        d="M7.666 21.25H16.335C19.355 21.25 21.25 19.111 21.25 16.084V7.916C21.25 4.889 19.365 2.75 16.335 2.75H7.666C4.636 2.75 2.75 4.889 2.75 7.916V16.084C2.75 19.111 4.636 21.25 7.666 21.25Z"
                        stroke="#EA0909"
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M12 16.086V7.914"
                        stroke="#EA0909"
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M15.748 12.3223L12 16.0863L8.25195 12.3223"
                        stroke="#EA0909"
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "info-square":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M11.9902 15.7961V11.3771"
                        stroke="#1268B3"
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M11.9891 8.2043H11.9991"
                        stroke="#1268B3"
                        {..._strokeCommonProps}
                    />
                    <path
                        {..._fillCommonProps}
                        d="M16.334 2.7502H7.665C4.644 2.7502 2.75 4.8892 2.75 7.9162V16.0842C2.75 19.1112 4.635 21.2502 7.665 21.2502H16.333C19.364 21.2502 21.25 19.1112 21.25 16.0842V7.9162C21.25 4.8892 19.364 2.7502 16.334 2.7502Z"
                        stroke="#1268B3"
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "file-download":
            iconSvg = (
                <svg
                    className={`fill-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        {..._fillCommonProps}
                        fill={fill || "#636E7C"}
                        d="M14.3277 2.0119C14.2855 2.00421 14.242 2.0002 14.1976 2.0002C14.1532 2.0002 14.1097 2.00421 14.0674 2.0119H7.93016C5.49031 2.0119 3.43359 4.02973 3.43359 6.4909V17.2279C3.43359 19.8254 5.39627 21.8649 7.93016 21.8649H15.7658C18.1746 21.8649 20.1604 19.7229 20.1604 17.2279V8.0379C20.1604 7.84426 20.0869 7.65812 19.9553 7.51845L14.986 2.24245C14.8472 2.09516 14.6556 2.0119 14.4553 2.0119H14.3277ZM13.4619 3.5111L7.93016 3.5119C6.29058 3.5119 4.90498 4.8713 4.90498 6.4909V17.2279C4.90498 19.0034 6.21526 20.3649 7.93016 20.3649H15.7658C17.3428 20.3649 18.689 18.9128 18.689 17.2279L18.6886 8.98328L17.8289 8.98627C17.5017 8.98587 17.1297 8.98516 16.716 8.9842C14.9795 8.98046 13.5627 7.59367 13.467 5.84761L13.4619 5.6592V3.5111ZM17.8833 7.48404L16.7193 7.4842C15.7321 7.48208 14.9333 6.66577 14.9333 5.6592V4.35215L17.8833 7.48404ZM11.4186 8.6908C11.7911 8.6908 12.0989 8.97295 12.1476 9.33903L12.1543 9.4408V14.1966L13.6818 12.634C13.9685 12.3405 14.4343 12.3395 14.7222 12.6318C14.9839 12.8975 15.0085 13.3141 14.7955 13.6081L14.7244 13.6924L11.9399 16.543L11.9395 16.5434C11.6781 16.8111 11.2679 16.8354 10.9794 16.6163L10.9728 16.6104C10.9483 16.5914 10.925 16.5708 10.903 16.5488L10.8968 16.5433L8.11297 13.6923C7.82632 13.3988 7.82738 12.9239 8.11534 12.6317C8.37713 12.366 8.7859 12.3427 9.07342 12.5613L9.15577 12.6341L10.6829 14.1989V9.4408C10.6829 9.02659 11.0123 8.6908 11.4186 8.6908Z"
                    />
                </svg>
            );

            break;

        case "arrow-up":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M5 15.5L12 8.5L19 15.5"
                        stroke={stroke || "#636E7C"}
                        {..._strokeCommonProps}
                        strokeWidth={"2"}
                    />
                </svg>
            );

            break;

        case "arrow-down":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M19 8.5L12 15.5L5 8.5"
                        stroke={stroke || "#636E7C"}
                        {..._strokeCommonProps}
                        strokeWidth={"2"}
                    />
                </svg>
            );

            break;

        case "credit-card":
            iconSvg = (
                <svg
                    className={`fill-ico ${_classList}`}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.81204 2.5H16.188C19.3978 2.5 22 5.16116 22 8.44374V9.24063V15.5563C22 18.8388 19.3978 21.5 16.188 21.5H7.81204C4.60219 21.5 2 18.8388 2 15.5563V9.24063V8.44374C2 5.16116 4.60219 2.5 7.81204 2.5ZM3.45358 9.94209V15.5563C3.45358 18.0179 5.40498 20.0135 7.81204 20.0135H16.188C18.595 20.0135 20.5464 18.0179 20.5464 15.5563V9.94209C20.4102 9.95844 20.2678 9.97029 20.1208 9.97711L19.8258 9.98389H4.17424C3.92165 9.98389 3.67911 9.96917 3.45358 9.94209ZM20.5464 8.53918C20.3209 8.5121 20.0784 8.49738 19.8258 8.49738H4.17424L3.87921 8.50416C3.73215 8.51098 3.58976 8.52283 3.45358 8.53918V8.44374C3.45358 5.98214 5.40498 3.98651 7.81204 3.98651H16.188C18.595 3.98651 20.5464 5.98214 20.5464 8.44374V8.53918ZM12.294 14.4402C12.6954 14.4402 13.0208 14.773 13.0208 15.1834C13.0208 15.5597 12.7473 15.8707 12.3926 15.9199L12.294 15.9267H11.9919C11.5905 15.9267 11.2651 15.5939 11.2651 15.1834C11.2651 14.8072 11.5386 14.4962 11.8933 14.447L11.9919 14.4402H12.294ZM15.044 14.4402C15.4454 14.4402 15.7708 14.773 15.7708 15.1834C15.7708 15.5597 15.4973 15.8707 15.1426 15.9199L15.044 15.9267H14.7419C14.3405 15.9267 14.0151 15.5939 14.0151 15.1834C14.0151 14.8072 14.2886 14.4962 14.6433 14.447L14.7419 14.4402H15.044ZM18.6277 15.1834C18.6277 14.773 18.3023 14.4402 17.9009 14.4402H17.5989L17.5002 14.447C17.1455 14.4962 16.8721 14.8072 16.8721 15.1834C16.8721 15.5939 17.1975 15.9267 17.5989 15.9267H17.9009L17.9995 15.9199C18.3543 15.8707 18.6277 15.5597 18.6277 15.1834Z"
                        fill={fill || "inherit"}
                    />
                </svg>
            );

            break;

        case "close":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M7.90381 6.90381L17.0962 16.0962"
                        stroke={stroke || "#200E32"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M17.0962 6.90381L7.90379 16.0962"
                        stroke={stroke || "#200E32"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "menu-edge-top":
            iconSvg = (
                <svg
                    className="menu-edge"
                    width={width || "10"}
                    height={height || "10"}
                    viewBox="10 10 10 10"
                    fill="none"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10 0C4.47715 0 0 4.47715 0 10V0H10ZM20 10C20 4.47715 15.5228 0 10 0H20V10ZM10 20C4.47715 20 0 15.5228 0 10V20H10ZM10 20C15.5228 20 20 15.5228 20 10V20H10Z"
                        fill={fill || "#ffffff"}
                    />
                </svg>
            );

            break;

        case "menu-edge-bottom":
            iconSvg = (
                <svg
                    className="menu-edge"
                    width={width || "10"}
                    height={height || "10"}
                    viewBox="10 0 10 10"
                    fill="none"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10 0C4.47715 0 0 4.47715 0 10V0H10ZM20 10C20 4.47715 15.5228 0 10 0H20V10ZM10 20C4.47715 20 0 15.5228 0 10V20H10ZM10 20C15.5228 20 20 15.5228 20 10V20H10Z"
                        fill="#f7f9ff"
                    />
                </svg>
            );

            break;

        case "left-circle":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.5 2.7502C7.392 2.7502 3.25 6.8912 3.25 12.0002C3.25 17.1082 7.392 21.2502 12.5 21.2502C17.608 21.2502 21.75 17.1082 21.75 12.0002C21.75 6.8912 17.608 2.7502 12.5 2.7502Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M13.9423 8.52899L10.4563 12L13.9423 15.471"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "right-circle":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.5 21.2498C17.608 21.2498 21.75 17.1088 21.75 11.9998C21.75 6.89179 17.608 2.74979 12.5 2.74979C7.392 2.74979 3.25 6.89179 3.25 11.9998C3.25 17.1088 7.392 21.2498 12.5 21.2498Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M11.0577 15.471L14.5437 12L11.0577 8.52898"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "logout":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <path
                        d="M15.516 7.38951V6.45651C15.516 4.42151 13.866 2.77151 11.831 2.77151H6.956C4.922 2.77151 3.272 4.42151 3.272 6.45651V17.5865C3.272 19.6215 4.922 21.2715 6.956 21.2715H11.841C13.87 21.2715 15.516 19.6265 15.516 17.5975V16.6545"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M22.3095 12.0214H10.2685"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M19.3812 9.10632L22.3092 12.0213L19.3812 14.9373"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );

            break;

        case "search":
            iconSvg = (
                <svg
                    className={`fill-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.1115 2C6.80323 2 2.5 6.20819 2.5 11.3993C2.5 16.5903 6.80323 20.7985 12.1115 20.7985C14.3819 20.7985 16.4684 20.0287 18.113 18.7415L21.2371 21.7886L21.3202 21.8586C21.6102 22.0685 22.0214 22.0446 22.2839 21.7873C22.5726 21.5043 22.572 21.0459 22.2825 20.7636L19.1952 17.7523C20.7649 16.0794 21.7231 13.8487 21.7231 11.3993C21.7231 6.20819 17.4198 2 12.1115 2ZM12.1115 3.44774C16.6022 3.44774 20.2426 7.00776 20.2426 11.3993C20.2426 15.7908 16.6022 19.3508 12.1115 19.3508C7.62086 19.3508 3.98044 15.7908 3.98044 11.3993C3.98044 7.00776 7.62086 3.44774 12.1115 3.44774Z"
                        fill={fill || "inherit"}
                    />
                </svg>
            );
            break;
        case "user":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <circle
                        cx="12.444141"
                        cy="7.1076307"
                        r="4.7780299"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        {..._fillCommonProps}
                        d="m 4.8651612,18.531001 c -0.00129,-0.3359 0.07383,-0.6677 0.21968,-0.9703 0.45766,-0.9153 1.7482804,-1.4004 2.8192204,-1.6201 0.7723593,-0.1648 1.5553893,-0.275 2.3432494,-0.3295 1.45863,-0.1282 2.92573,-0.1282 4.38443,0 0.7878,0.0552 1.5708,0.1653 2.3433,0.3295 1.0709,0.2197 2.3615,0.659 2.8192,1.6201 0.2933,0.6168 0.2933,1.3329 0,1.9497 -0.4577,0.9611 -1.7483,1.4004 -2.8192,1.611 -0.7715,0.1716 -1.5548,0.2848 -2.3433,0.3386 -1.1872,0.1007 -2.38,0.119 -3.5698,0.055 -0.2746,0 -0.54,0 -0.81463,-0.055 -0.7855401,-0.0531 -1.5658501,-0.1663 -2.3340994,-0.3386 -1.08009,-0.2106 -2.3615504,-0.6499 -2.8283704,-1.611 -0.1451,-0.3061 -0.22015,-0.6407 -0.21968,-0.9794 z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );
            break;

        case "users":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <path
                        d="M18.0949 10.9319C19.6972 10.9319 20.997 9.63295 20.997 8.03061C20.997 6.42828 19.6972 5.12936 18.0949 5.12936"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M19.4291 14.0847C19.9076 14.1177 20.3833 14.1856 20.8517 14.291C21.5026 14.4184 22.2854 14.6852 22.5641 15.2691C22.7419 15.6431 22.7419 16.0785 22.5641 16.4534C22.2863 17.0373 21.5026 17.3032 20.8517 17.437"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M6.78998 10.9319C5.18765 10.9319 3.88782 9.63295 3.88782 8.03061C3.88782 6.42828 5.18765 5.12936 6.78998 5.12936"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M5.45578 14.0847C4.97728 14.1177 4.50153 14.1856 4.03312 14.291C3.38228 14.4184 2.59945 14.6852 2.3217 15.2691C2.14295 15.6431 2.14295 16.0785 2.3217 16.4534C2.59853 17.0373 3.38228 17.3032 4.03312 17.437"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.4378 14.7096C15.6846 14.7096 18.4584 15.2009 18.4584 17.1671C18.4584 19.1325 15.7029 19.6421 12.4378 19.6421C9.19002 19.6421 6.4171 19.1508 6.4171 17.1846C6.4171 15.2183 9.1726 14.7096 12.4378 14.7096Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.4378 11.9049C10.2964 11.9049 8.57951 10.188 8.57951 8.04575C8.57951 5.90442 10.2964 4.1875 12.4378 4.1875C14.5791 4.1875 16.296 5.90442 16.296 8.04575C16.296 10.188 14.5791 11.9049 12.4378 11.9049Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );
            break;

        case "user-boss":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <circle
                        cx="12.079"
                        cy="7.27803"
                        r="4.77803"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.50002 18.7014C4.49873 18.3655 4.57385 18.0337 4.7197 17.7311C5.17736 16.8158 6.46798 16.3307 7.53892 16.111C8.31128 15.9462 9.09431 15.836 9.88217 15.7815C11.3408 15.6533 12.8079 15.6533 14.2666 15.7815C15.0544 15.8367 15.8374 15.9468 16.6099 16.111C17.6808 16.3307 18.9714 16.77 19.4291 17.7311C19.7224 18.3479 19.7224 19.064 19.4291 19.6808C18.9714 20.6419 17.6808 21.0812 16.6099 21.2918C15.8384 21.4634 15.0551 21.5766 14.2666 21.6304C13.0794 21.7311 11.8866 21.7494 10.6968 21.6854C10.4222 21.6854 10.1568 21.6854 9.88217 21.6304C9.09663 21.5773 8.31632 21.4641 7.54807 21.2918C6.46798 21.0812 5.18652 20.6419 4.7197 19.6808C4.5746 19.3747 4.49955 19.0401 4.50002 18.7014Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );
            break;

        case "lock":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <path
                        d="M16.9234 9.4478V7.3008C16.9234 4.7878 14.8854 2.7498 12.3724 2.7498C9.8594 2.7388 7.8134 4.7668 7.8024 7.2808V7.3008V9.4478"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.1832 21.2496H8.54221C6.44821 21.2496 4.75021 19.5526 4.75021 17.4576V13.1686C4.75021 11.0736 6.44821 9.3766 8.54221 9.3766H16.1832C18.2772 9.3766 19.9752 11.0736 19.9752 13.1686V17.4576C19.9752 19.5526 18.2772 21.2496 16.1832 21.2496Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M12.3629 14.2027V16.4237"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );
            break;

        case "archive":
            iconSvg = (
                <svg
                    className={`fill-ico ${_classList}`}
                    width={width || "24"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4 8.389C4 7.117 5.04 6.081 6.317 6.081H18.683C19.955 6.081 20.99 7.117 20.99 8.389V11.446C19.347 12.467 17.453 13.182 15.459 13.533C14.911 12.426 13.771 11.7 12.49 11.7C11.22 11.7 10.075 12.423 9.511 13.524C7.529 13.175 5.642 12.463 4 11.446V8.389ZM11.204 3.5H13.786C14.458 3.5 15.021 3.961 15.188 4.581H9.801C9.969 3.961 10.531 3.5 11.204 3.5ZM9.884 15.101C10.264 15.154 10.611 14.92 10.711 14.556C10.934 13.744 11.649 13.2 12.49 13.2C13.322 13.2 14.044 13.756 14.246 14.552C14.332 14.888 14.634 15.118 14.973 15.118C15.007 15.118 15.042 15.116 15.076 15.111C17.645 14.755 20.092 13.846 22.154 12.482C22.364 12.342 22.49 12.108 22.49 11.856V8.389C22.49 6.289 20.782 4.581 18.683 4.581H16.706C16.519 3.13 15.288 2 13.786 2H11.204C9.702 2 8.472 3.129 8.284 4.581H6.317C4.212 4.581 2.5 6.289 2.5 8.389V11.856C2.5 12.108 2.626 12.343 2.837 12.482C4.896 13.84 7.333 14.745 9.884 15.101ZM11.7451 15.3841V16.6781C11.7451 17.0921 12.0811 17.4281 12.4951 17.4281C12.9091 17.4281 13.2451 17.0921 13.2451 16.6781V15.3841C13.2451 14.9701 12.9091 14.6341 12.4951 14.6341C12.0811 14.6341 11.7451 14.9701 11.7451 15.3841ZM21.0086 15.4169C21.0386 15.0329 21.3516 14.7269 21.7446 14.7269C22.1576 14.7269 22.4926 15.0619 22.4926 15.4749C22.4926 15.4813 22.4807 15.6353 22.463 15.8639C22.4198 16.4213 22.3423 17.4221 22.3196 17.8079C22.2626 18.7459 21.8986 19.7029 21.3456 20.3689C20.5756 21.2969 19.5946 21.7309 18.2606 21.7339C17.6416 21.7349 15.0836 21.7359 12.5246 21.7359C9.9666 21.7359 7.4076 21.7349 6.7896 21.7339C5.4546 21.7309 4.4736 21.2969 3.7036 20.3679C3.1516 19.7029 2.7866 18.7459 2.7306 17.8079C2.70754 17.4277 2.63173 16.4502 2.58816 15.8884C2.56939 15.6464 2.5566 15.4815 2.5566 15.4749C2.5566 15.0619 2.8916 14.7269 3.3046 14.7269C3.6976 14.7269 4.0106 15.0329 4.0406 15.4169C4.0406 15.4169 4.1946 17.1659 4.2276 17.7179C4.2646 18.3289 4.5126 18.9939 4.8586 19.4099C5.3486 20.0009 5.8906 20.2319 6.7916 20.2339C8.0276 20.2359 17.0206 20.2359 18.2576 20.2339C19.1596 20.2319 19.7016 20.0009 20.1906 19.4109C20.5376 18.9939 20.7856 18.3289 20.8226 17.7179C20.8546 17.1659 21.0086 15.4169 21.0086 15.4169Z"
                        fill={fill || "inherit"}
                    />
                </svg>
            );
            break;

        case "dollar-round":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "25"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <path
                        d="M22.1389 14.3958H18.0906C16.6042 14.3949 15.3993 13.1909 15.3984 11.7045C15.3984 10.218 16.6042 9.01413 18.0906 9.01321H22.1389"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M18.5486 11.6429H18.2369"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.24766 3H16.8911C19.7892 3 22.1388 5.34951 22.1388 8.24766V15.4247C22.1388 18.3229 19.7892 20.6724 16.8911 20.6724H8.24766C5.34951 20.6724 3 18.3229 3 15.4247V8.24766C3 5.34951 5.34951 3 8.24766 3Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M7.53561 7.53817H12.9346"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );
            break;

        case "moneybag":
            iconSvg = (
                <svg
                    className={`fill-ico ${_classList}`}
                    width={width || "25"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <path
                        {..._fillCommonProps}
                        d="M15.2153 2.01191C15.1704 2.00423 15.1242 2.00021 15.0771 2.00021C15.0299 2.00021 14.9837 2.00423 14.9389 2.01191H8.42051C5.82957 2.01191 3.64551 4.02974 3.64551 6.49091V17.2039C3.64551 19.8045 5.73363 21.8649 8.42051 21.8649H16.7424C19.2979 21.8649 21.408 19.703 21.408 17.2039V8.03791C21.408 7.8443 21.33 7.65818 21.1903 7.51851L15.9143 2.24251C15.767 2.09519 15.5634 2.01191 15.3507 2.01191H15.2153ZM14.2958 3.51111L8.42051 3.51191C6.6794 3.51191 5.20801 4.87131 5.20801 6.49091V17.2039C5.20801 18.9851 6.60633 20.3649 8.42051 20.3649H16.7424C18.4114 20.3649 19.8455 18.8956 19.8455 17.2039L19.8448 8.9833L18.9329 8.98628C18.5853 8.98588 18.19 8.98517 17.7504 8.98421C15.9072 8.98047 14.4028 7.5935 14.3013 5.8476L14.2958 5.65921V3.51111ZM18.9898 7.48405L17.7538 7.48422C16.7065 7.48209 15.8583 6.66567 15.8583 5.65921V4.35266L18.9898 7.48405Z"
                        fill={fill || "inherit"}
                    />
                    <g
                        fill="inherit"
                        transform="translate(10.072541,7.8855891)"
                    >
                        <path
                            d="m 4.4986,4.91584 c 0.28956,0.29703 0.45989,0.66832 0.45989,1.12871 0,0.75743 -0.47692,1.23268 -1.02198,1.5 C 3.68102,7.66337 3.4085,7.75248 3.153,7.79703 V 8.40594 C 3.153,8.73267 2.84641,9 2.47169,9 2.09696,9 1.79037,8.73267 1.79037,8.40594 V 7.78218 C 1.31345,7.66337 0.887629,7.41089 0.581037,7.08416 0.138182,6.60891 -0.0662124,5.9703 0.018952,5.36139 0.0700507,5.03465 0.410708,4.81188 0.785432,4.85644 1.16015,4.90099 1.41565,5.19802 1.36455,5.52475 1.27939,5.98515 1.44971,6.11881 1.63708,6.34158 1.75631,6.4901 1.97773,6.65347 2.48872,6.74257 c 0.0511,0 0.47692,0.07426 0.80054,-0.19307 C 3.56179,6.31188 3.62992,5.94059 3.49366,5.70297 3.37443,5.5099 3.153,5.46535 2.93157,5.36139 2.38652,5.12376 1.44971,4.81188 0.683234,4.15842 0.564004,4.06931 0.342577,3.90594 0.206314,3.62376 0.0530178,3.34158 0.0359849,3.08911 0.0359849,2.95545 V 2.92574 C 0.018952,2.5396 0.121149,2.21287 0.325544,1.93069 0.529938,1.66337 0.802464,1.4703 1.07499,1.35149 1.31345,1.24752 1.58598,1.18812 1.82444,1.15842 V 0.594059 C 1.82444,0.267327 2.114,0 2.50575,0 2.89751,0 3.18707,0.252475 3.18707,0.594059 V 1.18812 C 3.64696,1.29208 4.05574,1.5 4.37937,1.81188 4.85629,2.27228 5.07772,2.89604 4.97552,3.5198 4.92442,3.84653 4.58376,4.05446 4.20904,4.0099 3.83432,3.96535 3.59586,3.66832 3.62992,3.34158 3.66399,3.10396 3.62992,2.9703 3.59586,2.88119 3.56179,2.82178 3.52773,2.73267 3.37443,2.59901 3.153,2.39109 2.88048,2.15347 2.47169,2.13861 2.42059,2.13861 1.92663,2.12376 1.68817,2.42079 1.44971,2.71782 1.56894,3.14851 1.75631,3.41584 1.84147,3.5495 1.97773,3.66832 3.54476,4.33663 3.80025,4.44059 4.17497,4.60396 4.51563,4.94554 Z"
                            fill={fill || "inherit"}
                        />
                    </g>
                </svg>
            );

            break;

        case "dollar-interactive":
            iconSvg = (
                <svg
                    className={`fill-ico stroke-ico ${_classList}`}
                    width={width || "20"}
                    height={height || "22"}
                    viewBox="0 0 20 22"
                    fill="none"
                >
                    <path
                        d="M5.70565 1H14.2941C16.9169 1.02857 19.0255 3.4 18.9998 6.31429V12.7571C18.9998 14.1571 18.5241 15.5 17.6369 16.5C16.7498 17.5 15.5541 18.0571 14.2941 18.0714H5.70565L1 21V6.31429C1 4.91429 1.47571 3.57143 2.36284 2.57143C3.24997 1.57143 4.44567 1.01429 5.70565 1V1Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <g
                        fill="inherit"
                        transform="translate(7.5681595,5.2896787)"
                    >
                        <path
                            d="m 4.4986,4.91584 c 0.28956,0.29703 0.45989,0.66832 0.45989,1.12871 0,0.75743 -0.47692,1.23268 -1.02198,1.5 C 3.68102,7.66337 3.4085,7.75248 3.153,7.79703 V 8.40594 C 3.153,8.73267 2.84641,9 2.47169,9 2.09696,9 1.79037,8.73267 1.79037,8.40594 V 7.78218 C 1.31345,7.66337 0.887629,7.41089 0.581037,7.08416 0.138182,6.60891 -0.0662124,5.9703 0.018952,5.36139 0.0700507,5.03465 0.410708,4.81188 0.785432,4.85644 1.16015,4.90099 1.41565,5.19802 1.36455,5.52475 1.27939,5.98515 1.44971,6.11881 1.63708,6.34158 1.75631,6.4901 1.97773,6.65347 2.48872,6.74257 c 0.0511,0 0.47692,0.07426 0.80054,-0.19307 C 3.56179,6.31188 3.62992,5.94059 3.49366,5.70297 3.37443,5.5099 3.153,5.46535 2.93157,5.36139 2.38652,5.12376 1.44971,4.81188 0.683234,4.15842 0.564004,4.06931 0.342577,3.90594 0.206314,3.62376 0.0530178,3.34158 0.0359849,3.08911 0.0359849,2.95545 V 2.92574 C 0.018952,2.5396 0.121149,2.21287 0.325544,1.93069 0.529938,1.66337 0.802464,1.4703 1.07499,1.35149 1.31345,1.24752 1.58598,1.18812 1.82444,1.15842 V 0.594059 C 1.82444,0.267327 2.114,0 2.50575,0 2.89751,0 3.18707,0.252475 3.18707,0.594059 V 1.18812 C 3.64696,1.29208 4.05574,1.5 4.37937,1.81188 4.85629,2.27228 5.07772,2.89604 4.97552,3.5198 4.92442,3.84653 4.58376,4.05446 4.20904,4.0099 3.83432,3.96535 3.59586,3.66832 3.62992,3.34158 3.66399,3.10396 3.62992,2.9703 3.59586,2.88119 3.56179,2.82178 3.52773,2.73267 3.37443,2.59901 3.153,2.39109 2.88048,2.15347 2.47169,2.13861 2.42059,2.13861 1.92663,2.12376 1.68817,2.42079 1.44971,2.71782 1.56894,3.14851 1.75631,3.41584 1.84147,3.5495 1.97773,3.66832 3.54476,4.33663 3.80025,4.44059 4.17497,4.60396 4.51563,4.94554 Z"
                            fill={fill || "inherit"}
                        />
                    </g>
                </svg>
            );

            break;

        case "mail":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "25"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <path
                        d="M17.7677 9.06113L13.5023 12.4954C12.6951 13.1283 11.5635 13.1283 10.7563 12.4954L6.45422 9.06113"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        {..._fillCommonProps}
                        d="M7.38787 3.5H16.8158C18.1752 3.51525 19.469 4.08993 20.396 5.0902C21.323 6.09048 21.8022 7.42903 21.722 8.79412V15.322C21.8022 16.6871 21.323 18.0256 20.396 19.0259C19.469 20.0262 18.1752 20.6009 16.8158 20.6161H7.38787C4.46796 20.6161 2.5 18.2407 2.5 15.322V8.79412C2.5 5.87545 4.46796 3.5 7.38787 3.5Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );
            break;

        case "cog":
            iconSvg = (
                <svg
                    className={`fill-ico ${_classList}`}
                    width={width || "25"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <path
                        {..._fillCommonProps}
                        d="M11.8853 2.10169L5.24174 4.37005C4.49797 4.62306 4 5.30545 4 6.07198V12.7097C4 14.7315 4.7529 16.6789 6.10912 18.196C6.74795 18.9121 7.56192 19.5077 8.54931 20.0259L12.1466 21.9118C12.3711 22.0295 12.6414 22.0294 12.8658 21.9116L16.4568 20.0269C17.4415 19.5095 18.2555 18.9127 18.8944 18.1964C20.2486 16.6804 21 14.7342 21 12.7136V6.07198C21 5.30545 20.502 4.62306 19.7574 4.36977L13.1156 2.10202C12.718 1.96605 12.2837 1.96605 11.8853 2.10169ZM12.6131 3.48951L19.2563 5.75777C19.3945 5.80477 19.4861 5.9303 19.4861 6.07198V12.7136C19.4861 14.3792 18.8668 15.9832 17.7508 17.2327L17.5525 17.4427C17.0722 17.9246 16.4672 18.3492 15.7369 18.7329L12.505 20.4283L9.26848 18.7316C8.4313 18.2922 7.76044 17.8013 7.25256 17.232C6.13446 15.9813 5.51389 14.3761 5.51389 12.7097V6.07198C5.51389 5.9303 5.6055 5.80477 5.74283 5.75805L12.3866 3.48962C12.4599 3.46466 12.5404 3.46466 12.6131 3.48951ZM16.2553 9.2399C15.9597 8.95269 15.4804 8.95269 15.1848 9.2399L11.7854 12.5422L10.4118 11.2062L10.3269 11.1349C10.0307 10.9212 9.61013 10.9448 9.34132 11.2059C9.04564 11.493 9.04551 11.9587 9.34104 12.246L11.2506 14.1023L11.3355 14.1735C11.6318 14.3872 12.0524 14.3636 12.3212 14.1024L16.2553 10.28L16.3286 10.1975C16.5485 9.90959 16.524 9.501 16.2553 9.2399Z"
                        fill={fill || "inherit"}
                    />
                </svg>
            );
            break;

        case "key":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "25"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <path
                        {..._fillCommonProps}
                        d="M16.8344 2.75021H8.1654C5.1444 2.75021 3.2504 4.88921 3.2504 7.91621V16.0842C3.2504 19.1112 5.1354 21.2502 8.1654 21.2502H16.8334C19.8644 21.2502 21.7504 19.1112 21.7504 16.0842V7.91621C21.7504 4.88921 19.8644 2.75021 16.8344 2.75021Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        {..._fillCommonProps}
                        d="M11.1923 12.0002C11.1923 13.0222 10.3633 13.8522 9.3403 13.8522C8.3183 13.8522 7.4893 13.0222 7.4893 12.0002C7.4893 10.9782 8.3183 10.1482 9.3403 10.1482C10.3633 10.1482 11.1923 10.9782 11.1923 12.0002Z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M11.1923 12.0002H17.5103V13.8522"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        d="M14.6816 13.8517V11.9997"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                </svg>
            );
            break;

        case "user-check":
            iconSvg = (
                <svg
                    className={`stroke-ico ${_classList}`}
                    width={width || "25"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <circle
                        cx="9.4601269"
                        cy="6.9859171"
                        r="4.7780299"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <path
                        {..._fillCommonProps}
                        d="m 1.8811463,18.409287 c -0.00129,-0.3359 0.07383,-0.6677 0.21968,-0.9703 0.45766,-0.9153 1.74828,-1.4004 2.81922,-1.6201 0.77236,-0.1648 1.55539,-0.275 2.34325,-0.3295 1.45863,-0.1282 2.9257307,-0.1282 4.3844307,0 0.7878,0.0552 1.5708,0.1653 2.3433,0.3295 1.0709,0.2197 2.3615,0.659 2.8192,1.6201 0.2933,0.6168 0.2933,1.3329 0,1.9497 -0.4577,0.9611 -1.7483,1.4004 -2.8192,1.611 -0.7715,0.1716 -1.5548,0.2848 -2.3433,0.3386 -1.1872,0.1007 -2.3800007,0.119 -3.5698007,0.055 -0.2746,0 -0.54,0 -0.81463,-0.055 -0.78554,-0.0531 -1.56585,-0.1663 -2.3341,-0.3386 -1.08009,-0.2106 -2.36155,-0.6499 -2.82837,-1.611 -0.1451,-0.3061 -0.22015,-0.6407 -0.21968,-0.9794 z"
                        stroke={stroke || "inherit"}
                        {..._strokeCommonProps}
                    />
                    <g
                        fill="none"
                        transform="matrix(1.0416667,0,0,1.0416667,-30.727104,-12.398502)"
                    >
                        <g transform="matrix(1.0531843,0,0,1.0849767,27.757407,9.0039495)">
                            <g
                                fill="none"
                                transform="translate(14.466894,8.2459361)"
                            >
                                <path
                                    d="m 1.9786487,5.496304 2.2068528,2.3435989 4.1967,-4.0078125"
                                    stroke={stroke || "inherit"}
                                    {..._strokeCommonProps}
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            );
            break;

        case "share":
            iconSvg = (
                <svg
                    className={`fill-ico stroke-ico ${_classList}`}
                    width={width || "25"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <g>
                        <g>
                            <path
                                {..._fillCommonProps}
                                d="m 8.73356,3.4321278 c -1.4195776,0 -2.5594973,1.1397464 -2.5594973,2.5594974 0,1.4194186 1.1400736,2.5594975 2.5594973,2.5594975 1.419756,0 2.559498,-1.1399344 2.559498,-2.5594975 0,-1.419905 -1.139598,-2.5594974 -2.559498,-2.5594974 z m 0,0.7959338 c 1.0211999,0 1.745064,0.7423684 1.745064,1.7635636 0,1.020892 -0.7240571,1.7543131 -1.745064,1.7543131 -1.0207138,0 -1.7450636,-0.7335992 -1.7450636,-1.7543131 0,-1.0210122 0.7241717,-1.7635636 1.7450636,-1.7635636 z"
                                fill={fill || "inherit"}
                                strokeWidth="0.6"
                            />
                            <g
                                fill="none"
                                transform="matrix(0.88572648,-0.37342262,0.51724764,0.63944287,14.451103,3.9190601)"
                            >
                                <path
                                    d="m -5.3130463,2.2255638 2.4493576,5.8997271"
                                    stroke={stroke || "inherit"}
                                    {..._strokeCommonProps}
                                />
                                <path
                                    d="m -10.767075,11.994985 6.2020618,-0.419749"
                                    stroke={stroke || "inherit"}
                                    {..._strokeCommonProps}
                                />
                            </g>
                            <path
                                {..._fillCommonProps}
                                d="m 18.279501,8.8680112 c -1.419577,0 -2.559497,1.1397468 -2.559497,2.5594968 0,1.419419 1.140074,2.559498 2.559497,2.559498 1.419756,0 2.559498,-1.139935 2.559498,-2.559498 0,-1.419904 -1.139598,-2.5594968 -2.559498,-2.5594968 z m 0,0.7959338 c 1.0212,0 1.745064,0.742369 1.745064,1.763563 0,1.020892 -0.724057,1.754313 -1.745064,1.754313 -1.020713,0 -1.745063,-0.733599 -1.745063,-1.754313 0,-1.021011 0.724171,-1.763563 1.745063,-1.763563 z"
                                fill={fill || "inherit"}
                                strokeWidth="0.6"
                            />
                            <path
                                {..._fillCommonProps}
                                d="m 8.691113,13.724705 c -1.419577,0 -2.559497,1.139747 -2.559497,2.559497 0,1.419419 1.140074,2.559498 2.559497,2.559498 1.419756,0 2.559498,-1.139935 2.559498,-2.559498 0,-1.419904 -1.139598,-2.559497 -2.559498,-2.559497 z m 0,0.795934 c 1.0212,0 1.745064,0.742369 1.745064,1.763563 0,1.020892 -0.724057,1.754313 -1.745064,1.754313 -1.020713,0 -1.745063,-0.733599 -1.745063,-1.754313 0,-1.021011 0.724171,-1.763563 1.745063,-1.763563 z"
                                fill={fill || "inherit"}
                                strokeWidth="0.6"
                            />
                        </g>
                    </g>
                </svg>
            );
            break;

        case "cycle":
            iconSvg = (
                <svg
                    className={`fill-ico stroke-ico ${_classList}`}
                    width={width || "25"}
                    height={height || "24"}
                    viewBox="0 0 25 24"
                    fill="none"
                >
                    <path
                        {..._fillCommonProps}
                        d="M7.85854 3.23021C7.56443 3.01114 7.14618 3.03548 6.87966 3.30323L2.80188 7.3999L2.72946 7.48419C2.51228 7.7783 2.53745 8.19491 2.80433 8.46056L2.88862 8.53298C3.18273 8.75016 3.59934 8.72499 3.86499 8.45811L6.6611 5.64851V17.4507L6.66795 17.5524C6.71761 17.9185 7.03141 18.2007 7.4111 18.2007C7.82532 18.2007 8.1611 17.8649 8.1611 17.4507V5.64864L10.9574 8.45811L11.0414 8.53092C11.3345 8.74945 11.7512 8.72621 12.0181 8.46056C12.3117 8.16834 12.3128 7.69347 12.0205 7.3999L7.94277 3.30323L7.93757 3.29873C7.91468 3.27617 7.89035 3.25507 7.86473 3.23558L7.85854 3.23021ZM18.0827 6.44468C18.033 6.0786 17.7192 5.79645 17.3395 5.79645C16.9253 5.79645 16.5895 6.13223 16.5895 6.54645V18.3481L13.7932 15.539L13.7093 15.4662C13.4162 15.2477 12.9994 15.2709 12.7326 15.5366C12.439 15.8288 12.4379 16.3036 12.7301 16.5972L16.8079 20.6939L16.8131 20.6984C16.836 20.721 16.8603 20.7421 16.8859 20.7615L16.8921 20.7669C17.1862 20.986 17.6045 20.9616 17.871 20.6939L21.9488 16.5972L22.0212 16.5129C22.2384 16.2188 22.2132 15.8022 21.9463 15.5366C21.6527 15.2443 21.1779 15.2454 20.8857 15.539L18.0895 18.3472V6.54645L18.0827 6.44468Z"
                        fill={fill || "inherit"}
                    />
                </svg>
            );
            break;
    }

    return iconSvg;
};
